"use client";

import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  id: "",
  cashier: "",
  startingCash: 0,
  status: "close",
  cashierShortOverAmount: 0,
  stockShortOverAmount: 0,
  endCashRemaining: 0,
  inventorySnapShot: [],
};

const shiftSlice = createSlice({
  name: "shift",
  initialState,
  reducers: {
    setShiftSession(state, action) {
      state.id = action.payload.id;
      state.cashier = action.payload.cashier;
      state.startingCash = action.payload.startingCash;
      state.status = action.payload.status;
      state.cashierShortOverAmount = 0;
      state.stockShortOverAmount = 0;
      state.endCashRemaining = 0;

      state.listOfProductsWithVariance =
        action.payload.listOfProductsWithVariance || [];
      state.inventorySnapShot = action.payload.inventorySnapShot || [];
    },

    setCashierShortOverAmount(state, action) {
      state.cashierShortOverAmount = action.payload.amountResult;
    },

    setStockShort(state, action) {
      const {
        productId,
        productName,
        variance,
        endingStock,
        physicalCount,
        sellingPrice,
        amount,
        soldAmount,
      } = action.payload;

      const snapShotIndex = state.inventorySnapShot.findIndex(
        (item) => item.productId === productId
      );

      if (snapShotIndex !== -1) {
        state.inventorySnapShot[snapShotIndex] = {
          productId,
          productName,
          variance,
          endingStock,
          physicalCount,
          sellingPrice,
          amount,
          soldAmount,
        };
      } else {
        // Add new
        state.inventorySnapShot.push({
          productId,
          productName,
          variance,
          endingStock,
          physicalCount,
          sellingPrice,
          amount,
          soldAmount,
        });
      }

      state.stockShortOverAmount = state.inventorySnapShot.reduce(
        (accum, current) => accum + current.amount,
        0
      );
    },

    setCashRemaining(state, action) {
      state.endCashRemaining = action.payload.cash;
    },

    resetCashRemaining(state, action) {
      state.endCashRemaining = 0;
    },

    resetShiftState(state, action) {
      return initialState;
    },
  },
});

export const {
  setCashierShortOverAmount,
  setShiftSession,
  resetShiftState,
  setStockShort,
  setCashRemaining,
  resetCashRemaining,
} = shiftSlice.actions;

export default shiftSlice.reducer;
